import { AnchoredPanel, BookmarkablePage, useNavigation } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { ConsoleContext } from "../../console/ConsoleContext";
import { EXADB_LIST_ROUTE, PageId, PageRegistrationConfig } from "../../constants/pluginConstants";
import {
  DatabaseSummaryLifecycleStateEnum,
  DatabaseSummaryStatusEnum,
  PluggableDatabaseSummaryLifecycleStateEnum,
  PluggableDatabaseSummaryStatusEnum,
} from "../../gen/clients/mchub-azure-api-client-exa";
import { ExaDbList } from "./ExaDbList";

const registrationIds = PageRegistrationConfig[PageId.EXADB_LIST].map(config => config.key);

export interface ExadataItem {
  id: string;
  displayName: string;
  subscriptionId: string;
  subscriptionName: string;
  resourceGroupName: string;
  location: string;
  containerDBName?: string;
  containerDBId?: string;
  isPdb: boolean;
  lifecycleState: PluggableDatabaseSummaryLifecycleStateEnum | DatabaseSummaryLifecycleStateEnum;
  status: PluggableDatabaseSummaryStatusEnum | DatabaseSummaryStatusEnum;
}

export const ExaDbListPage = (): JSX.Element => {
  const { back, navigateToSelf } = useNavigation(ConsoleContext);

  React.useEffect(() => {
    // In case page was navigated to directly by entring its URL in the browser
    navigateToSelf(EXADB_LIST_ROUTE, registrationIds[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BookmarkablePage
      appContext={ConsoleContext}
      registrationIds={registrationIds}
      title={Messages.listExaDb.titles.short()}
    >
      <AnchoredPanel
        anchorId="page"
        title={Messages.listExaDb.titles.long()}
        onClose={back}
        isOpen
      >
        <ExaDbList />
      </AnchoredPanel>
    </BookmarkablePage>
  );
};
